<!--
 * @Descripttion: 查看专区
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div style="padding: 0" class="zone-mgmt-edit">
    <div class="zone-mgmt-edit-header">{{ id ? '编辑专区' : '新增专区' }}</div>
    <div class="zone-mgmt-edit-body">
      <BaseForm
        style="margin: 20px; flex: 1"
        class="zone-mgmt-edit-body-left"
        ref="formRef"
        label-position="right"
        :model="formData"
      >
        <BaseFormItem
          v-bind="BaseFormItemBaseConfig"
          label="专区名称"
          prop="title"
          :rules="[
            {
              required: true,
              message: '专区名称不能为空',
              trigger: 'blur'
            }
          ]"
        >
          <BaseInput
            placeholder=""
            style="width: 100%"
            v-model="formData.title"
            show-word-limit
            :maxlength="20"
          ></BaseInput>
        </BaseFormItem>
        <div
          style="
            border-top: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            padding: 20px 0 0 0;
            position: relative;
          "
          v-for="(item, index) in formData.banners"
          :key="index"
        >
          <div
            v-if="index !== 0"
            style="position: absolute; right: 0; cursor: pointer; z-index: 1"
            class="del"
          >
            <div @click="onDelBanner(index)">
              <BaseIcon size="20" color="#4c4c4c" class="addition-icon">
                <Delete />
              </BaseIcon>
            </div>
          </div>
          <div v-if="index === 0">
            <span style="color: #ff0b0b; font-size: 14px; margin-right: 2px">
              *
            </span>
            <span style="color: #4c4c4c; font-size: 14px">封面图</span>
            <BaseButton @click="onAddBanner" style="margin: 10px">
              添加封面
            </BaseButton>
          </div>
          <BaseFormItem
            v-bind="BaseFormItemBaseConfig"
            style="flex-direction: column"
            :prop="'banners.' + index"
            :rules="[
              {
                required: true,
                trigger: 'blur',
                validator: (_, _value, callback) => {
                  if (_value.imgUrl.length === 0) {
                    return callback('请上传封面图');
                  }
                  callback();
                }
              }
            ]"
          >
            <BaseUpload
              style="width: 248px"
              ref="baseUploadRefVideoCover"
              listType="picture-card"
              :accept="['.jpg', '.png', '.jpeg', '.bmp']"
              :limit="1"
              :limitSize="20"
              :autoUpload="true"
              :onError="onError"
              :httpRequest="
                e => {
                  httpRequest(e, index);
                }
              "
              @change="onChangeUpload('banners.' + index)"
              v-model:fileList="item.imgUrl"
            >
              <template #tip>
                <span style="color: #898989; font-size: 14px">
                  建议上传 16：9, 最大 20M,格式为JPEG,JPG,BMP,PNG 的图片
                </span>
              </template>
            </BaseUpload>
          </BaseFormItem>
          <BaseFormItem
            v-bind="BaseFormItemBaseConfig"
            label="跳转内容"
            prop="id"
          >
            <BaseSelect
              style="width: 100%"
              v-model="item.id"
              placeholder="请选择跳转内容"
              label-key="title"
              value-key="id"
              init
              clearable
              filterUseRemote
              :remoteMethod="getJumpContent"
              @change="
                (e, selectOptions) => {
                  onChangeSelect(selectOptions, index);
                }
              "
            ></BaseSelect>
          </BaseFormItem>
        </div>
        <div style="margin-top: 20px">
          <div
            style="justify-content: flex-start; margin: 10px"
            class="xrk-form-item__label"
          >
            <span style="color: #ff0b0b; font-size: 14px; margin-right: 2px">
              *
            </span>
            <span>推广内容</span>
            <BaseButton @click="onAddRelation" style="margin-left: 10px">
              请选择推广内容
            </BaseButton>
          </div>
          <div class="drag-table-header">
            <div
              style="
                width: 70px;
                border-left: 1px solid #f6f6f6;
                border-right: 1px solid #f6f6f6;
              "
              class="drag-table-header-item"
            >
              序号
            </div>
            <div
              style="width: 110px; border-right: 1px solid #f6f6f6"
              class="drag-table-header-item"
            >
              编号ID
            </div>
            <div
              style="
                width: 130px;
                border-right: 1px solid #f6f6f6;
                padding: 0 10px;
              "
              class="drag-table-header-item"
            >
              资讯标题
            </div>
            <div
              style="width: 150px; border-right: 1px solid #f6f6f6"
              class="drag-table-header-item"
            >
              作者
            </div>
            <div
              v-if="hasForm"
              style="width: 130px; border-right: 1px solid #f6f6f6"
              class="drag-table-header-item"
            >
              关联表单编号
            </div>
            <div
              style="width: 100px; border-right: 1px solid #f6f6f6"
              class="drag-table-header-item"
            >
              资讯状态
            </div>
            <div
              style="width: 83px; border-right: 1px solid #f6f6f6"
              class="drag-table-header-item"
            >
              操作
            </div>
          </div>
          <div
            style="
              text-align: center;
              line-height: 400px;
              border: 1px solid #f6f6f6;
            "
            v-if="relationTableData.length == 0"
          >
            暂无数据
          </div>
          <draggable
            style="height: 340px; overflow: auto; border: 1px solid #f6f6f6"
            v-model="relationTableData"
            v-else
            animation="500"
            handle=".move"
            @start="drag = true"
            @end="onDragEnd"
          >
            <template #item="{ element, index }">
              <div
                :style="{
                  background: index % 2 ? '#F4F4F5' : '#fff',
                  borderBottom: '1px solid #f6f6f6'
                }"
                class="drag-table-header"
              >
                <div
                  style="
                    width: 70px;
                    border-left: 1px solid #f6f6f6;
                    border-right: 1px solid #f6f6f6;
                  "
                  class="drag-table-header-item"
                >
                  {{ index + 1 }}
                </div>
                <div
                  style="width: 110px; border-right: 1px solid #f6f6f6"
                  class="drag-table-header-item"
                >
                  {{ element.infoCode }}
                </div>
                <BaseToolTip :content="element.title">
                  <div
                    style="
                      width: 130px;
                      border-right: 1px solid #f6f6f6;
                      padding: 0 10px;
                    "
                    class="drag-table-header-item"
                  >
                    {{ element.title }}
                  </div>
                </BaseToolTip>
                <div
                  style="width: 150px; border-right: 1px solid #f6f6f6"
                  class="drag-table-header-item"
                >
                  {{ element.author }}
                </div>
                <div
                  v-if="hasForm"
                  style="width: 130px; border-right: 1px solid #f6f6f6"
                  class="drag-table-header-item"
                >
                  <BaseButton
                    style="font-size: 14px"
                    type="text"
                    :disabled="!element.surveyCode || !element.surveyId"
                    @click="onPreviewForm(element)"
                  >
                    {{ element.surveyCode }}
                  </BaseButton>
                </div>
                <div
                  style="width: 100px; border-right: 1px solid #f6f6f6"
                  class="drag-table-header-item"
                >
                  <BaseSwitch
                    :loading="switchLoading"
                    :before-change="
                      async () => {
                        await switchBeforeChange(element);
                      }
                    "
                    v-model="element.visible"
                    :active-value="1"
                    :inactive-value="0"
                  ></BaseSwitch>
                </div>
                <div
                  style="width: 83px; border-right: 1px solid #f6f6f6"
                  class="drag-table-header-item"
                >
                  <BaseButton
                    @click="onRemoveRelation(element, index)"
                    style="font-size: 14px"
                    type="text"
                  >
                    移除
                  </BaseButton>
                  <img
                    src="https://cdn.myxrk.com/myxrk-v2/front-end/assets/oss/topic/svg/yidong.svg"
                    class="move"
                    style="cursor: move; margin-left: 9px"
                  />
                </div>
              </div>
            </template>
          </draggable>
        </div>
      </BaseForm>
      <div v-if="hasForm" class="zone-mgmt-edit-body-right">
        <div class="zone-mgmt-edit-body-right-title">规则设置</div>
        <div style="border-bottom: 1px solid #f6f6f6; padding-bottom: 10px">
          <div style="font-size: 14px; color: #818181; margin: 10px 0">
            移动端常规形式
          </div>
          <div>
            <BaseSwitch
              size="large"
              v-model="formData.mobileShowMode"
              active-text="平铺显示"
              inactive-text="折叠显示"
              :active-value="1"
              :inactive-value="2"
            ></BaseSwitch>
          </div>
        </div>
        <div style="border-bottom: 1px solid #f6f6f6; padding-bottom: 10px">
          <div style="font-size: 14px; color: #818181; margin: 10px 0">
            排序
          </div>
          <div>
            <BaseSwitch
              size="large"
              v-model="formData.sortMode"
              active-text="自动排序"
              inactive-text="手动设置"
              :active-value="2"
              :inactive-value="1"
            ></BaseSwitch>
          </div>
        </div>
      </div>
    </div>
    <div class="affix-box">
      <BaseButton type="default" @click="onCancelClick">取消</BaseButton>
      <BaseButton @click="onSave">保存</BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { useRoute, useRouter } from 'vue-router';
import { reactive, ref } from 'vue';
import {
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseFormRef,
  createDialog,
  BaseSwitch,
  XrkMessage,
  BaseUpload,
  BaseIcon,
  BaseToolTip
} from 'xrk-components';
import {
  zoneDetail,
  promotionContent,
  addOrUpdate,
  checkInfoStatus
} from '../data-source/apis';
import { uploadApi } from '@data-source/common/apis';
import draggable from 'vuedraggable';
import AddRelation from '../components/add-relation.vue';
import { Delete } from '@element-plus/icons-vue';
import QuestionPreview from '../components/question-preview.vue';

const route = useRoute();
const router = useRouter();

const id: number = +route.query?.id || null;
const hasForm: number = +route.query?.hasForm;

const relationTableData = ref([]);

const drag = ref(false);

const BaseFormItemBaseConfig = {
  'label-width': '110px',
  'label-position': 'top'
};

type DataType = {
  id?: number;
  title: string;
  sortMode: number; //排序方式   1 手动设置  2 自动倒序
  mobileShowMode: number; // 移动端展示样式  1 平铺显示 2 折叠显示
  banners: {
    id?: number;
    imgUrl: any[];
    title: string;
  }[];
};

const formRef = ref<BaseFormRef<DataType>>();

const formData = reactive<DataType>({
  title: '',
  banners: [
    {
      imgUrl: [],
      title: '',
      id: null
    }
  ],
  sortMode: 2,
  mobileShowMode: 1
});

const onAddBanner = () => {
  if (formData.banners.length >= 5) {
    XrkMessage.warning('封面图最多上传 5 张');
    return;
  }
  formData.banners.push({
    imgUrl: [],
    title: '',
    id: null
  });
};

const switchLoading = ref(false);
const switchBeforeChange = async row => {
  switchLoading.value = true;
  return new Promise((resolve, reject) => {
    checkInfoStatus({
      infoId: row.id,
      hasForm,
      status: +!row.visible
    })
      .then(() => {
        resolve(true);
      })
      .catch(() => {
        reject(false);
      })
      .finally(() => {
        switchLoading.value = false;
      });
  });
};

const onPreviewForm = async row => {
  await createDialog({
    title: '预览',
    showClose: true,
    showFooter: false,
    customClass: 'zone-mgmt-question-preview',
    contentRender: () => (
      <div style="padding:20px">
        <QuestionPreview
          projectType={row.sceneType}
          tempId={row.surveyId}
        ></QuestionPreview>
      </div>
    )
  });
  const dialogElement = document.querySelector('.zone-mgmt-question-preview');
  if (dialogElement) {
    (dialogElement as HTMLElement).style.height = '900px';
    (dialogElement as HTMLElement).style.maxHeight = '900px';
  }
};

const onChangeUpload = key => {
  formRef.value.validateField(key);
};
const onDelBanner = (index: number) => {
  formData.banners.splice(index, 1);
};

const onChangeSelect = (selectOptions, index) => {
  formData.banners[index].title = selectOptions[0].title;
};

const addRelationRef = ref(null);
const onAddRelation = () => {
  createDialog({
    width: 960,
    title: '选择推广内容',
    showClose: true,
    showFooter: false,
    contentRender: () => (
      <>
        <AddRelation
          ref={addRelationRef}
          relationTableData={relationTableData}
          hasForm={hasForm}
        ></AddRelation>
      </>
    ),
    footerRender: done => (
      <>
        <BaseButton onClick={done} type="default">
          关闭
        </BaseButton>
        <BaseButton
          onClick={() => {
            const data = addRelationRef.value.getSelectionRows();
            if (data.length === 0) {
              XrkMessage.error('请至少选择1条资讯');
              return;
            }
            relationTableData.value = data;
            done();
          }}
          type="primary"
        >
          保存
        </BaseButton>
      </>
    )
  });
};

const getJumpContent = async title => {
  const data = await promotionContent({
    title: title,
    hasForm,
    pageSize: 80
  });
  if (hasForm === 1) {
    data.data.list.forEach(item => {
      item.title = `${item.title}（${item.surveyCode}）`;
    });
  }
  return data;
};

const initData = async () => {
  if (id) {
    const { data } = await zoneDetail({ id, hasForm });
    formData.banners = data.banners.map(item => {
      return {
        imgUrl: [item.imgUrl],
        title: item.title,
        id: item.id
      };
    });
    formData.title = data.title;
    formData.id = data.id;
    formData.sortMode = data.sortMode;
    formData.mobileShowMode = data.mobileShowMode;
    relationTableData.value = data.relationships.reverse();
    formData.banners = data.banners.map(item => {
      return {
        imgUrl: [{ url: item.imgUrl }],
        title: item.title,
        id: item.id
      };
    });
  }
};

const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};

const httpRequest = ({ file }: { file: File }, index) => {
  return new Promise((resolve, reject) => {
    uploadApi({ file })
      .then(res => {
        formData.banners[index].imgUrl[0].url = res.data.fileUrl;
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const onRemoveRelation = async (row, index) => {
  relationTableData.value.splice(index, 1);
  XrkMessage.success('移除成功');
};

const onDragEnd = async () => {
  drag.value = false;
};

const onSave = async () => {
  await formRef.value?.validate();
  if (relationTableData.value.length === 0) {
    XrkMessage.warning('请选择推广内容');
    return;
  }
  //组合数据
  const params = {
    ...formData,
    id,
    hasForm,
    banners: formData.banners.map(item => {
      return {
        id: item.id,
        imgUrl: item.imgUrl[0].url,
        title: item.title
      };
    }),
    relationships: relationTableData.value.map((item, index) => {
      return {
        id: item.id,
        visible: item.visible,
        weight: index
      };
    })
  };
  await addOrUpdate(params);
  XrkMessage.success('保存成功');
  router.back();
};

const onCancelClick = () => {
  createDialog({
    width: 350,
    title: '提示',
    showClose: true,
    content: '当前页面有未保存内容，是否继续返回',
    beforeConfirm: async done => {
      done();
      router.back();
    }
  });
};

if (id) {
  initData();
}
</script>
<style lang="scss" scoped>
.zone-mgmt-edit {
  display: flex;
  flex-direction: column;

  ::v-deep {
    .xrk-switch__label,
    .xrk-form-item__label {
      font-size: 14px !important;
    }
  }
  &-body {
    display: flex;
    flex: 1;
    height: 100%;
    overflow-y: auto;
    &-right {
      border-left: 1px solid #f0f0f0;
      border-bottom: 1px solid #f0f0f0;
      padding: 20px;
      width: 447px;
      &-title {
        font-weight: 600;
        font-size: 16px;
        color: #1a1a1a;
      }
    }
  }
  &-header {
    width: 100%;
    height: 68px;
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 18px;
    color: #1a1a1a;
    line-height: 22px;
    font-weight: 600;
  }
  .drag-table {
    &-header {
      background: #f6f6f6;
      font-weight: 600;
      font-size: 14px;
      display: flex;
      justify-content: space-around;
      flex-wrap: nowrap;
      height: 50px;
      line-height: 50px;
      &-item {
        flex-grow: 1;
        text-align: center;
        overflow: hidden; /* 确保超出容器的文本被隐藏 */
        white-space: nowrap; /* 防止文本换行 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
      }
    }
  }
}
</style>
